import "@/App.css";
import "@/index.css";
import {
    BrowserRouter,
    Routes,
    Route,
    useLocation,
} from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AuthCallback from "./components/AuthCallback";
import CookieBanner from "./components/CookieBanner";
import { Toaster } from "sonner";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import VerifyEmail from "./pages/VerifyEmail";
import Legal from "./pages/legal/Legal";
import ComingSoon from "./pages/ComingSoon";

import RespondentDashboard from "./pages/respondent/RespondentDashboard";
import SurveyList from "./pages/respondent/SurveyList";
import SurveyTake from "./pages/respondent/SurveyTake";
import Wallet from "./pages/respondent/Wallet";
import Profile from "./pages/respondent/Profile";
import Referrals from "./pages/respondent/Referrals";

import AdvertiserDashboard from "./pages/advertiser/AdvertiserDashboard";
import SurveyBuilder from "./pages/advertiser/SurveyBuilder";
import SurveyAnalytics from "./pages/advertiser/SurveyAnalytics";

import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminSurveys from "./pages/admin/AdminSurveys";
import AdminPayouts from "./pages/admin/AdminPayouts";
import AdminAudit from "./pages/admin/AdminAudit";
import AdminConfig from "./pages/admin/AdminConfig";
import AdminExtensions from "./pages/admin/AdminExtensions";
import AdminKB from "./pages/admin/AdminKB";

import HelpIndex from "./pages/help/HelpIndex";
import HelpArticle from "./pages/help/HelpArticle";
import Contact from "./pages/Contact";
import ForAdvertisers from "./pages/ForAdvertisers";
import FAQ from "./pages/FAQ";
import PaymentSuccess from "./pages/advertiser/PaymentSuccess";

function AppRouter() {
    const location = useLocation();
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/coming-soon" element={<ComingSoon />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/legal/:slug" element={<Legal />} />
            <Route path="/help" element={<HelpIndex />} />
            <Route path="/help/:slug" element={<HelpArticle />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/for-advertisers" element={<ForAdvertisers />} />
            <Route path="/faq" element={<FAQ />} />

            <Route
                path="/respondent"
                element={
                    <ProtectedRoute roles={["respondent"]}>
                        <RespondentDashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/respondent/surveys"
                element={
                    <ProtectedRoute roles={["respondent"]}>
                        <SurveyList />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/respondent/surveys/:id"
                element={
                    <ProtectedRoute roles={["respondent"]}>
                        <SurveyTake />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/respondent/wallet"
                element={
                    <ProtectedRoute roles={["respondent"]}>
                        <Wallet />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/respondent/profile"
                element={
                    <ProtectedRoute roles={["respondent"]}>
                        <Profile />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/respondent/referrals"
                element={
                    <ProtectedRoute roles={["respondent"]}>
                        <Referrals />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/advertiser"
                element={
                    <ProtectedRoute roles={["advertiser"]}>
                        <AdvertiserDashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/advertiser/surveys/new"
                element={
                    <ProtectedRoute roles={["advertiser"]}>
                        <SurveyBuilder />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/advertiser/surveys/:id/edit"
                element={
                    <ProtectedRoute roles={["advertiser"]}>
                        <SurveyBuilder />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/advertiser/surveys/:sid/payment-success"
                element={
                    <ProtectedRoute roles={["advertiser"]}>
                        <PaymentSuccess />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/advertiser/surveys/:id"
                element={
                    <ProtectedRoute roles={["advertiser"]}>
                        <SurveyAnalytics />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/admin"
                element={
                    <ProtectedRoute roles={["admin"]}>
                        <AdminDashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/users"
                element={
                    <ProtectedRoute roles={["admin"]}>
                        <AdminUsers />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/surveys"
                element={
                    <ProtectedRoute roles={["admin"]}>
                        <AdminSurveys />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/payouts"
                element={
                    <ProtectedRoute roles={["admin"]}>
                        <AdminPayouts />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/audit"
                element={
                    <ProtectedRoute roles={["admin"]}>
                        <AdminAudit />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/config"
                element={
                    <ProtectedRoute roles={["admin"]}>
                        <AdminConfig />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/extension-requests"
                element={
                    <ProtectedRoute roles={["admin"]}>
                        <AdminExtensions />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/kb"
                element={
                    <ProtectedRoute roles={["admin"]}>
                        <AdminKB />
                    </ProtectedRoute>
                }
            />
        </Routes>
    );
}

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <AppRouter />
                <CookieBanner />
                <Toaster position="top-right" richColors theme="light" />
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
